export const THEMATICS = {
  BANK: 'FILTERS_THEMATICS_BANK',
  LETTER_PACKAGE: 'FILTERS_THEMATICS_LETTER',
  DT: 'FILTERS_THEMATICS_TERRITORIAL',
  EXCELLENCE: 'FILTERS_THEMATICS_EXCELLENCE',
  INNOVATION: 'FILTERS_THEMATICS_INNOVATION',
  INTERNATIONAL: 'FILTERS_THEMATICS_INTERNATIONAL',
  LOGISTIC: 'FILTERS_THEMATICS_LOGISTIC',
  MEDIA: 'FILTERS_THEMATICS_MEDIA',
  PARTNERSHIP: 'FILTERS_THEMATICS_PARTNERSHIP',
  HUMAN_RESOURCES: 'FILTERS_THEMATICS_HUMAN_RESOURCES',
  HOME_SERVICE: 'FILTERS_THEMATICS_SERVICES',
  TELECOM: 'FILTERS_THEMATICS_TELECOM',
  DIGITAL: 'FILTERS_THEMATICS_DIGITAL',
  ECOLOGY: 'FILTERS_THEMATICS_ECOLOGY',
};
